import $ from 'jquery'

export default function Content({ article }) {

  const injectClass = () => {
    $('iframe[src*=\'www.instagram.com\']').each(async(idx, item) => {

      const ig_url = $(item).attr('src')
      const url = ig_url.replace('/embed', '/')
      console.log('url:', url)
      const query_url = 'https://graph.facebook.com/v13.0/instagram_oembed?url=' + url + '&fields=thumbnail_width,thumbnail_height&access_token=1706804032925164|be32388353cee6f2fe1ea73a47f14739'

      const fw = $('.article').width()
      const frame = item
      $(item).css('border', '1px solid #ddd')
      $(item).css('border-radius', '3px')

      const res = await fetch(query_url)
      const result = await res.json()
      console.log('result:', result)
      var width = result.thumbnail_width
      var height = result.thumbnail_height
      console.log('width:', width)
      console.log('height:', height)
      if (width > 0 && height > 0) {
        var fh = fw * height / width + 54 + 44 + 108
        frame.height = fh
        frame.width = fw - 1
      }

    })

    $('iframe[src*=\'www.youtube.com\']').each(async(idx, item) => {
      $(item).wrap('<div class=\'embed-youtube\'></div>')
      console.log('youtube wrap')
    })

    $('iframe[src*=\'www.facebook.com/plugins/video.php\']').each(async(idx, item) => {
      if ($(item).parent().hasClass('embed-facebook') == false) {
        $(item).wrap('<div class=\'embed-facebook\'></div>')
        console.log('update facebook wrap')
      }
    })

    const alinkList = $('.article a')
    for (let i = 0; i < alinkList.length; i++) {
      const link = alinkList[i]
      const linkObj = $(link)
      const href = linkObj.attr('href')
      if (!href) continue
      const userLink = href.match(/.*\/user\/(\d+$)/)
      if (!userLink) continue
      const stylistUserId = Number(userLink[1])
      linkObj.text(h.path.full.stylist({ id: stylistUserId }))
      linkObj.attr('href', h.path.stylist({ id: stylistUserId }))
    }

  }

  useEffect(() => {
    injectClass()
  }, [])

  return (
    <>
      <div className='text-gray-400 font-light text-xs pb-2'>
        { article.date.ymd('/') } · { article.author.name }
      </div>
      <div className='text-[0.95rem] leading-6 article wp-container-7' dangerouslySetInnerHTML={ { __html: article.content } }/>
      <style>
        {`
          .embed-youtube, .embed-facebook {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
            width: 100%;
            height: 0;
           }

           .embed-youtube iframe, .embed-facebook iframe {
             position: absolute;
             top: 0;
             left: 0;
             width: 100%;
             height: 100%;
           }
        `}
      </style>
    </>
  )
}
